import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getData } from '../../services/api';
import AuthProductBrand from '../../components/auth/AuthProductBrand';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [industries, setIndustries] = useState([]);
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({ organizationName: '', industryId: '', planId: '', firstName: '', lastName: '', email: '', password: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);

  useEffect(() => {
    Promise.all([
      getData('/auth/industries').catch(() => ({})),
      getData('/auth/plans').catch(() => ({})),
    ]).then(([ind, pl]) => {
      setIndustries(Array.isArray(ind?.data) ? ind.data : Array.isArray(ind) ? ind : []);
      setPlans(Array.isArray(pl?.data) ? pl.data : Array.isArray(pl) ? pl : []);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  const f = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  return (
    <div className="auth-glass" style={{ maxWidth: 520 }}>
      <AuthProductBrand />
      <h4 className="text-center fw-bold mb-1">Create Your Organization</h4>
      <p className="text-center text-muted mb-4" style={{ fontSize: 13 }}>Set up your ERP in minutes</p>

      {error && <div className="alert alert-danger py-2 mb-3" style={{ fontSize: 13 }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        {step === 1 && (
          <>
            <h6 className="fw-semibold mb-3" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#c4b5fd' }}>Step 1: Organization</h6>
            <div className="mb-3">
              <label className="form-label">Organization Name *</label>
              <input type="text" className="form-control" placeholder="Acme School / My Company" value={form.organizationName} onChange={e => f('organizationName', e.target.value)} required />
            </div>
            <div className="mb-3">
              <label className="form-label">Industry *</label>
              <select className="form-select" value={form.industryId} onChange={e => f('industryId', e.target.value)} required>
                <option value="">Select industry...</option>
                {industries.map(i => <option key={i._id} value={i._id}>{i.name}</option>)}
              </select>
            </div>
            <div className="mb-4">
              <label className="form-label">Subscription Plan *</label>
              <div className="row g-2">
                {plans.map(plan => (
                  <div className="col-4" key={plan._id}>
                    <div
                      className={`pick-card p-2 text-center ${form.planId === plan._id ? 'active' : ''}`}
                      onClick={() => f('planId', plan._id)}
                    >
                      <div className="fw-bold" style={{ fontSize: 13 }}>{plan.name}</div>
                      <div style={{ fontSize: 11, opacity: 0.75 }}>₹{plan.price?.monthly}/mo</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button type="button" className="btn btn-primary w-100" onClick={() => setStep(2)} disabled={!form.organizationName || !form.industryId || !form.planId}>
              Next: Admin Account →
            </button>
          </>
        )}
        {step === 2 && (
          <>
            <h6 className="fw-semibold mb-3" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: 1, color: '#c4b5fd' }}>Step 2: Admin Account</h6>
            <div className="row g-3">
              <div className="col-6">
                <label className="form-label">First Name *</label>
                <input type="text" className="form-control" value={form.firstName} onChange={e => f('firstName', e.target.value)} required />
              </div>
              <div className="col-6">
                <label className="form-label">Last Name *</label>
                <input type="text" className="form-control" value={form.lastName} onChange={e => f('lastName', e.target.value)} required />
              </div>
              <div className="col-12">
                <label className="form-label">Email *</label>
                <input type="email" className="form-control" value={form.email} onChange={e => f('email', e.target.value)} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">Password *</label>
                <input type="password" className="form-control" value={form.password} onChange={e => f('password', e.target.value)} required minLength={6} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Phone</label>
                <input type="tel" className="form-control" value={form.phone} onChange={e => f('phone', e.target.value)} />
              </div>
            </div>
            <div className="d-flex gap-2 mt-4">
              <button type="button" className="btn btn-secondary" onClick={() => setStep(1)}>← Back</button>
              <button type="submit" className="btn btn-primary flex-fill" disabled={loading}>
                {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : null}
                Create Organization
              </button>
            </div>
          </>
        )}
      </form>
      <div className="text-center mt-3" style={{ fontSize: 13 }}>Already registered? <Link to="/login">Sign in</Link></div>
    </div>
  );
}
